import React, { createContext, useContext, useState, useCallback } from 'react';

const FooterGlowContext = createContext();

export const useFooterGlow = () => {
  const context = useContext(FooterGlowContext);
  if (!context) {
    throw new Error('useFooterGlow must be used within a FooterGlowProvider');
  }
  return context;
};

export const FooterGlowProvider = ({ children }) => {
  const [shouldGlow, setShouldGlow] = useState(false);

  const triggerGlow = useCallback(() => {
    setShouldGlow(true);
    // Remove the glow class after animation completes (1 second)
    setTimeout(() => {
      setShouldGlow(false);
    }, 1000);
    
    // Scroll to footer after a short delay
    setTimeout(() => {
      const footer = document.querySelector('.footer');
      if (footer) {
        footer.scrollIntoView({ behavior: 'smooth', block: 'end' });
      }
    }, 100);
  }, []);

  return (
    <FooterGlowContext.Provider value={{ shouldGlow, triggerGlow }}>
      {children}
    </FooterGlowContext.Provider>
  );
};

